import { all, call, put, takeEvery } from "redux-saga/effects";

import * as t from "./actionType";
import * as a from "./action";

import {
  getCallInboundList,
  getCallInboundListByCustomer,
  getCallInboundData,
  createCallInbound,
  updateCallInbound,
  deleteCallInbound,
} from "../../helpers/fakebackend_helper";

function* listSaga() {
  try {
    yield put(a.callInboundListSuccess(yield call(getCallInboundList)));
  } catch (e) {
    yield put(a.callInboundListFail(e));
  }
}

function* listByCustomerSaga({ data }) {
  try {
    yield put(
      a.callInboundListByCustomerSuccess(
        yield call(getCallInboundListByCustomer, data)
      )
    );
  } catch (e) {
    yield put(a.callInboundListByCustomerFail(e));
  }
}

function* dataSaga({ data }) {
  try {
    yield put(a.callInboundDataSuccess(yield call(getCallInboundData, data)));
  } catch (e) {
    yield put(a.callInboundDataFail(e));
  }
}

function* createSaga({ data }) {
  try {
    yield put(a.callInboundCreateSuccess(yield call(createCallInbound, data)));
  } catch (e) {
    yield put(a.callInboundCreateFail(e));
  }
}

function* updateSaga({ data }) {
  try {
    yield put(a.callInboundUpdateSuccess(yield call(updateCallInbound, data)));
  } catch (e) {
    yield put(a.callInboundUpdateFail(e));
  }
}

function* deleteSaga({ data }) {
  try {
    yield put(a.callInboundDeleteSuccess(yield call(deleteCallInbound, data)));
  } catch (e) {
    yield put(a.callInboundDeleteFail(e));
  }
}

function* CallInboundSaga() {
  yield all([
    takeEvery(t.CALL_INBOUND_LIST, listSaga),
    takeEvery(t.CALL_INBOUND_LIST_BY_CUSTOMER, listByCustomerSaga),
    takeEvery(t.CALL_INBOUND_DATA, dataSaga),
    takeEvery(t.CALL_INBOUND_CREATE, createSaga),
    takeEvery(t.CALL_INBOUND_UPDATE, updateSaga),
    takeEvery(t.CALL_INBOUND_DELETE, deleteSaga),
  ]);
}

export default CallInboundSaga;
